import i18n from 'i18next';

export const columns = [
  {
    id: 'type',
    numeric: false,
    disablePadding: false,
    label: i18n.t('Type'),
    needSorting: true,
  },
  {
    id: 'requestDate',
    numeric: false,
    disablePadding: false,
    label: i18n.t('Request Date (UTC)'),
    needSorting: true,
  },
  {
    id: 'startDate',
    numeric: false,
    disablePadding: false,
    label: i18n.t('paymentInformation.start'),
    needSorting: true,
  },
  {
    id: 'endDate',
    numeric: false,
    disablePadding: false,
    label: i18n.t('paymentInformation.end'),
    needSorting: true,
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: i18n.t('Status'),
    needSorting: true,
  },
  {
    id: 'action',
    numeric: false,
    disablePadding: false,
    label: i18n.t('Actions'),
    needSorting: false,
    align: 'left',
  },
];
